import { computed, readonly, ref, type ComputedRef, type Ref } from 'vue';
import { useIsMobile } from './useIsMobile';

// Tables trim their column set on phones only while the phone is held
// upright. Tilting to landscape brings the full desktop column set back
// (scrolling horizontally if it doesn't fit) even on phones whose landscape
// width stays under the 768px breakpoint — the rest of the phone layout
// (floating menu, stacked headers, comparison bar) still follows `useIsMobile`.
const PORTRAIT_MEDIA_QUERY = '(orientation: portrait)';

const isPortrait = ref(true);

// Guarded for non-browser environments (jsdom in unit tests).
if (typeof window !== 'undefined' && typeof window.matchMedia === 'function') {
  const query = window.matchMedia(PORTRAIT_MEDIA_QUERY);
  isPortrait.value = query.matches;
  query.addEventListener('change', (event) => {
    isPortrait.value = event.matches;
  });
}

/** Reactive flag: the viewport is taller than it is wide. Module-level singleton. */
export function useIsPortrait(): Readonly<Ref<boolean>> {
  return readonly(isPortrait);
}

/**
 * True when tables should show their compact (phone) column set: a phone-sized
 * viewport held in portrait. Landscape phones get the full table.
 */
export function useCompactTables(): ComputedRef<boolean> {
  const isMobile = useIsMobile();
  return computed(() => isMobile.value && isPortrait.value);
}
